import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-synchronize-style-toggle',
    templateUrl: './web-synchronize-style-toggle.component.html',
    styleUrls: ['./web-synchronize-style-toggle.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, TooltipModule, TranslateModule],
})
export class WebSynchronizeStyleToggleComponent {
    @Input() public active: boolean;
}
